import React from 'react'

import AboutUsPage from './about-us-page'

export default function AboutUs() {
    return <AboutUsPage />
}
